import { camelizeKeys } from "humps";
import { prop } from "ramda";
import { BC_API_V1, BC_HQ } from "app_constants";
import {
  checkStatus,
  getRequest,
  makeAuthHeaders,
  parseJSON,
  postRequest,
} from "helpers/requests";

import type { IRole, IZone } from "types/user";
import type IPosUser from "types/user/pos_user";

function getAllRoles(permalink: string): Promise<IRole[]> {
  return fetch(
    `${BC_HQ}/${permalink}/roles.json`,
    getRequest(makeAuthHeaders())
  )
    .then(checkStatus)
    .then(parseJSON)
    .then((d) => camelizeKeys(prop("roles", d)) as IRole[]);
}

function getAllZones(permalink: string): Promise<IZone[]> {
  return fetch(
    `${BC_API_V1}/zones.json?restaurant_id=${permalink}`,
    getRequest(makeAuthHeaders())
  )
    .then(checkStatus)
    .then(parseJSON)
    .then((d) => camelizeKeys(prop("zones", d)) as IZone[]);
}

export interface ICreatePosUserUserAttributes {
  // Required attributes
  username: string;
}

export interface ICreatePosUserPosUserRoleAttributes {
  // Required attributes
  isDefault: number;
  _destroy: string; // "true" || "false"
  payRate: string;
  roleId: string;

  // Optional attributes
  id?: number;
  zoneId?: string;
}

export interface ICreatePosUserAttributes {
  // Required attributes
  firstName: string;
  lastName: string;

  // Optional attributes
  employeeIdAn?: string;
  pincode?: string;
  nameOnCreditCard?: string;
  lastFourDigitsOfCreditCard?: string;

  // Required nested attributes
  userAttributes: ICreatePosUserUserAttributes;
  posUserRolesAttributes: {
    [index: string]: ICreatePosUserPosUserRoleAttributes;
  };
}

function postCreatePosUser(
  permalink: string,
  posUser: ICreatePosUserAttributes
): Promise<IPosUser> {
  return fetch(
    `${BC_HQ}/${permalink}/pos_users.json`,
    postRequest({ posUser }, makeAuthHeaders())
  )
    .then(checkStatus)
    .then(parseJSON)
    .then((userResponse) => camelizeKeys(userResponse.pos_user) as IPosUser);
}

export const Breadcrumb = {
  getAllRoles,
  getAllZones,
  postCreatePosUser,
};
